import { type FC } from "react";

import { SearchableCard, Spacing } from "@snapchat/snap-design-system";
import { useIntl } from "react-intl";

import { type ResourceContainer } from "../../../gql-generated/types";
import { SearchContainer } from "../../../layout/components";
import { useSelectedOrganizationContainer } from "../../hooks";
import { type Feature } from "../../models";
import { SearchableListContainer, SearchableListSizeConfig } from "../../styles";
import { ContainerDisplay } from "../ContainerDisplay";

import { ListOfFolders } from "./FolderSearchList.styles";
import { messages } from "./messages.generated";

interface FolderSearchListProps {
    searchText: string;
    setSearchText: (searchText: string) => void;
    lensFoldersList: readonly ResourceContainer[];
    headerChildren?: React.ReactNode;
}

export const FolderSearchListV2: FC<FolderSearchListProps> = ({
    searchText,
    setSearchText,
    lensFoldersList,
    headerChildren,
}) => {
    const { uniqueId } = useSelectedOrganizationContainer();
    const intl = useIntl();

    const lensFolders = lensFoldersList.filter(({ id, name }) => name.includes(searchText) || id.includes(searchText));

    return (
        <SearchableListContainer
            height={SearchableListSizeConfig.height + Spacing.MD}
            width={SearchableListSizeConfig.width}
        >
            {headerChildren}
            <SearchableCard
                onSearch={setSearchText}
                searchValue={searchText}
                searchPlaceholder={intl.formatMessage(messages.searchFolders)}
                padBody={false}
                searchTestId="folder-search__search-box"
            >
                <SearchContainer
                    loading={false}
                    height={SearchableListSizeConfig.height}
                    noResults={lensFolders.length === 0}
                >
                    <ListOfFolders>
                        {lensFolders
                            .map((lensFolder) => {
                                if (!uniqueId) {
                                    return null;
                                }

                                return (
                                    <ContainerDisplay
                                        key={lensFolder.id}
                                        container={{
                                            name: lensFolder.name,
                                            id: lensFolder.id,
                                            features: new Set<Feature>(),
                                        }}
                                        selectedContainerId={uniqueId}
                                        orgId={lensFolder.parentName}
                                        lensFolderId={lensFolder.id}
                                    />
                                );
                            })
                            .filter((el) => !!el)}
                    </ListOfFolders>
                </SearchContainer>
            </SearchableCard>
        </SearchableListContainer>
    );
};
